import React, { useEffect, useState } from 'react'
import { Grid, Typography } from '@mui/material'
import useStyles from './useStyles'
import TopesTable from './TableNavigable/TableNavigable'
import { useDispatch } from 'react-redux'
import { getParametersApplication } from '../../../../app/services/eAuthz/getAllApplicationParameterEAuthz'
import { setErrorTextSnackBar, setRequestTextSnackBar } from '../../../../redux/actions/app'

export const BoxTopes = ({ parameters = [], appCode, refresh, applicationInstanceId }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [appParameters, setappParameters] = useState([])
  const getParamsByApp = async (appCode) => {
    try {
      const resp = await getParametersApplication(appCode)
      if (resp.data?.data) {
        setappParameters(resp.data?.data)
      }
    } catch (error) {
      console.log(error)
      setappParameters([])
      dispatch(setRequestTextSnackBar())
      dispatch(setErrorTextSnackBar("Ocurrió un error al cargar los modulos de la aplicación."))
    }
  }

  useEffect(() => {
    if (appCode) getParamsByApp(appCode)
  }, [appCode])

  return (
    <Grid container className={classes.boxTopes}>
      <Grid item xs={12}>
        <Typography
          style={{
            fontSize: 20,
            fontWeight: 'bold',
            color: '#4B4952',
            paddingLeft: 10,
            borderBottom: '1px solid rgba(36, 55, 143, 0.2)'
          }}
        >
          Topes
        </Typography>
      </Grid>
      <TopesTable appParameters={appParameters} parameters={parameters} refresh={refresh} />
    </Grid>
  )
}
